import styled from  'styled-components'

export const DivContainer = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`
export const DivContentResult = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    >div{
        font-size:60px;
    }
    >h5{
        text-align :center;
        font-size :20px;
        
    }
`;